import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The forests in PAs of Karnataka are undergoing tumultuous changes
              due to unplanned activities with tourism, mining, and other
              activities. The current research analyses the spatiotemporal
              changes in the select PAs such as Someshwara Wildlife Sanctuary
              (SWLS) and Bhadra Wildlife Sanctuary (BWLS). Land use and Land
              cover (LULC) analyses highlights as the evergreen cover have
              reduced from 38.75 to 31.43% by 2016 in SWLS and loss of deciduous
              forests from 50.09 to 37.43 % in BWLS (1973-2016) with an increase
              of plantations, agriculture activities, which are threatening the
              ecological integrity of the region. The Markov Cellular automata
              (MCA) based visualisation reveals loss of deciduous forest cover
              from 37.43 to 34.71 % in BWLS by 2026 with an increase in
              agricultural activities along the edges of forests. SWLS shows
              loss of evergreen cover (31.43 to 28.84%) due to penetrations of
              horticulture crops (constitute 18.5 %) and settlements.
            </p>
            <p>
              Spatial Decision Support System (SDSS) is designed taking
              advantage of the recent advances in information and open source
              web technologies, through the integration of spatial with
              attribute information. This enhances governance transparency while
              meeting societal needs, which helps in the prudent planning of the
              protected areas (PA). Visualisation of landscape dynamics through
              synthesis and integration of information would enable
              understanding the current status and predict likely changes, which
              are essential for effective decision-making towards sustainable
              management of natural resources. Web-based spatial decision
              support system (WSDSS) would help in accomplishing effective
              dissemination of the ecological, socio, economic, biodiversity and
              environmental information. Integration of temporal, spatial
              information with the simulation techniques facilitates
              visualisation in order to analyse the viability of decisions
              through exploratory analysis based on multiple criteria, which
              enable a detailed comparative analysis of alternate scenarios.{" "}
            </p>
            <p>
              &nbsp;<strong>Keywords: </strong>Protected Areas, SDSS, Land use
              Land cover, CA-Markov, Sustainability, Conservation
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
